import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

function LegalSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mb-12">
      <h2
        className="mb-4 text-gray-900"
        style={{
          fontFamily: 'Cormorant Garamond, serif',
          fontWeight: 500,
          fontSize: '22px',
        }}
      >
        {title}
      </h2>
      <div
        className="text-sm text-gray-600 leading-relaxed space-y-3"
        style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
      >
        {children}
      </div>
    </div>
  );
}

export default function Legal() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <main className="flex-1 pt-24">
        {/* Header */}
        <div className="px-6 md:px-10 lg:px-16 py-16 md:py-20 border-b border-gray-100">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-px bg-gray-300" />
            <span
              className="text-xs tracking-widest uppercase text-gray-400"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Mentions légales
            </span>
          </div>
          <h1
            className="text-gray-900"
            style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontWeight: 300,
              fontSize: 'clamp(32px, 4vw, 56px)',
              lineHeight: '1.1',
            }}
          >
            Conditions <em style={{ fontStyle: 'italic' }}>générales</em>
          </h1>
          <p
            className="mt-4 text-sm text-gray-400"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
          >
            Dernière mise à jour : mars 2026
          </p>
        </div>

        {/* Content */}
        <div className="px-6 md:px-10 lg:px-16 py-16 md:py-24">
          <div className="max-w-3xl">

            <LegalSection title="1. Présentation de l'entreprise">
              <p>
                Le présent site est édité par <strong className="font-medium text-gray-800">WABICH</strong>, entreprise individuelle enregistrée sous le statut d&apos;entrepreneur individuel.
              </p>
              <p>
                Dirigeante : Joanna Maria Wabich<br />
                SIRET : 102 006 269 00017<br />
                Code NAF : 74.10Z – Activités spécialisées de design<br />
                Adresse : 91 Rue Nationale, 59800 Lille, France<br />
                Email : joannawab1ch@outlook.com<br />
                Téléphone : +33 6 99 06 88 40
              </p>
            </LegalSection>

            <LegalSection title="2. Objet du site">
              <p>
                Ce site web a pour objet de présenter les services de design créatif proposés par WABICH, notamment le design graphique, l&apos;identité visuelle et la conception créative pour les entreprises et les particuliers.
              </p>
              <p>
                Le site constitue un support de communication et de prospection commerciale. Il ne s&apos;agit pas d&apos;une boutique en ligne et aucune vente directe n&apos;est réalisée via ce site.
              </p>
            </LegalSection>

            <LegalSection title="3. Propriété intellectuelle">
              <p>
                Tous les contenus présents sur ce site — textes, images, graphismes, logos, icônes, illustrations — sont la propriété exclusive de WABICH ou de ses ayants droit et sont protégés par les lois françaises et internationales relatives au droit de la propriété intellectuelle.
              </p>
              <p>
                Toute reproduction, distribution, modification ou utilisation de ces contenus, même partielle, sans autorisation écrite préalable de WABICH est strictement interdite.
              </p>
            </LegalSection>

            <LegalSection title="4. Responsabilité">
              <p>
                WABICH s&apos;efforce de maintenir les informations publiées sur ce site à jour et exactes. Toutefois, WABICH ne saurait être tenu responsable des erreurs, omissions ou des résultats qui pourraient être obtenus par un mauvais usage des informations présentes sur ce site.
              </p>
              <p>
                Le site peut contenir des liens vers des sites tiers. WABICH décline toute responsabilité quant aux contenus de ces sites externes.
              </p>
            </LegalSection>

            <LegalSection title="5. Droit applicable">
              <p>
                Les présentes conditions générales sont soumises au droit français. Tout litige relatif à l&apos;utilisation du site ou à son contenu sera de la compétence exclusive des tribunaux de Lille, France.
              </p>
            </LegalSection>

            <LegalSection title="6. Contact">
              <p>
                Pour toute question relative à ces conditions, vous pouvez contacter WABICH à l&apos;adresse suivante :{' '}
                <a
                  href="mailto:joannawab1ch@outlook.com"
                  className="text-gray-800 underline underline-offset-2 hover:text-gray-900 cursor-pointer"
                >
                  joannawab1ch@outlook.com
                </a>
              </p>
            </LegalSection>

            <div className="pt-8 border-t border-gray-100 flex flex-col sm:flex-row gap-4">
              <Link
                to="/politique-de-confidentialite"
                className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
              >
                <i className="ri-arrow-right-line text-base" />
                Politique de confidentialité
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
              >
                <i className="ri-arrow-right-line text-base" />
                Nous contacter
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
